import React from "react";
import "./Ventures.scss";

const ventures = [
    {
        name: "Nabeba",
        initial: "N",
        category: "Logistics & Technology",
        description:
            "A technology venture focused on logistics, bringing digital innovation to the movement of goods.",
        theme: "nabeba",
        website: "https://nabeba.com/", // Add the full Nabeba website URL.
    },
    {
        name: "Goldensoko",
        initial: "G",
        category: "Technology Venture",
        description:
            "A venture developed by Techadive, turning ideas into practical digital products.",
        theme: "goldensoko",
        website: "https://goldensoko.com/", // Add the full Goldensoko website URL.
    },
];

const Ventures = () => {
    return (
        <section
            className="ventures"
            id="ventures"
            aria-labelledby="ventures-title"
        >
            <div className="ventures__inner">
                <div className="ventures__header">
                    <div>
                        <p className="ventures__eyebrow">Built by Techadive</p>

                        <h2 id="ventures-title">
                            Our <span>Ventures.</span>
                        </h2>
                    </div>

                    <p className="ventures__intro">
                        We bring our own ideas to life through technology, thoughtful
                        design, and a drive to solve practical challenges.
                    </p>
                </div>

                <ul className="ventures__grid">
                    {ventures.map((venture) => (
                        <li key={venture.name}>
                            <article
                                className={`ventures__card ventures__card--${venture.theme}`}
                                aria-labelledby={`venture-${venture.theme}-title`}
                            >
                                <div className="ventures__visual" aria-hidden="true">
                                    <div className="ventures__ring ventures__ring--outer" />
                                    <div className="ventures__ring ventures__ring--inner" />

                                    <span className="ventures__monogram">
                    {venture.initial}
                  </span>
                                </div>

                                <div className="ventures__content">
                                    <p className="ventures__category">{venture.category}</p>

                                    <h3 id={`venture-${venture.theme}-title`}>
                                        {venture.name}
                                    </h3>

                                    <p className="ventures__description">
                                        {venture.description}
                                    </p>

                                    <div className="ventures__card-footer">
                                        {venture.website && (
                                            <a
                                                className="ventures__link"
                                                href={venture.website}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Visit {venture.name}
                                                <span aria-hidden="true">↗</span>
                                                <span className="ventures__sr-only">
                          {" "}
                                                    (opens in a new tab)
                        </span>
                                            </a>
                                        )}

                                        <p className="ventures__credit">
                                            <span aria-hidden="true" />
                                            Developed by Techadive
                                        </p>
                                    </div>
                                </div>
                            </article>
                        </li>
                    ))}
                </ul>

                <div className="ventures__footer">
                    <p>Interested in collaborating on our ventures?</p>

                    <a className="ventures__contact" href="#contact">
                        Connect with Techadive
                        <span aria-hidden="true">↗</span>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Ventures;